<template>
  <div class="main">
    <div class="tablediv">
      <div class="total-title">
        <span class="OD-span1">
          订单号
          <span class="OD-span2">{{orderNo}}</span>
        </span>
        <div style="float:right;clear:both;">
          <span class="OD-span3">
            下单时间 {{orderDate}}
            <span class="OD-span4">已完成</span>
          </span>
        </div>
      </div>
      <el-row class="row-style">
        <el-col :span="24" class="select-title">
          <span>设备列表</span>
        </el-col>
      </el-row>
      <div class="tablepad">
        <el-table
          :data="tableData"
          style="width: 100%"
          empty-text="暂无设备"
          header-row-class-name="tableHead"
          :header-cell-style="{'background-color':'#8D99AB'}"
          cell-class-name="tableTbody"
        >
          <el-table-column prop="dvsno" label="印宝编号"></el-table-column>
          <el-table-column prop="beforeValidity" label="购买前有效期">
            <template slot-scope="scope">
              <span class="service" :class="[scope.row.beforeValidity != '无服务'?'orange':'']">{{scope.row.beforeValidity}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="afterValidity" label="购买后有效期">
            <template slot-scope="scope">
              <span class="orderdeline">{{scope.row.afterValidity}}</span>
            </template>
          </el-table-column>
        </el-table>
        <el-row>
          <el-col :span="24" class="pad-top txt-right">
            <span class="OD-span5">
              共
              <span class="orange">{{ordersum}}</span>台印宝
            </span>
            <span class="pad-left OD-span5">
              单价
              <span class="orange">{{price}}</span>
            </span>
            <span class="pad-left OD-span5">
              购买
              <span class="orange">{{year}}年</span>服务
            </span>
          </el-col>
        </el-row>
        <el-row>
          <el-col class="totalprice txt-right">
            <span class="OD-span6">
              总价
              <span class="orange">{{totalprice}}元</span>
            </span>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import util from "../components/util";
export default util.useCommon({
  data() {
    return {
      ordersum: 15,
      year: 0,
      orderNo: "",
      info:"",
      orderDate: "",
      price: 0,
      gtype:"",
      gmodel:"",
      totalprice: 0,
      tableData: []
    };
  },
  computed: {},
  methods: {
    query() {
      var v = this;
      v.dopost(
        "/order/getPrice",
        {
          gmodel:v.gmodel,
          gtype :v.gtype
        },
        function(result) {
          if ("0000" === result.state) {
            v.price = result.body.unitprice + result.body.unitname;
          } else {
            var msg = [];
            for (var i = 0; i < result.body.length; i++) {
              msg.push(result.body[i].errmsg);
            }
            v.message("error", msg.join("<br/>"));
          }
          console.log(result);
        }
      );
    },
  },
  created: function() {},
  activated() {
    var v = this;
    if (!v.nyy.userInfo) {
      v.$router.replace("/");
    }else{
      v.nyy.userInfo = JSON.parse(localStorage.getItem("userInfo"));
      v.owner = v.nyy.userInfo.owner;
      v.corp = v.nyy.userInfo.corp;
      var para = getJsonPara(v.$route);
      v.info = para.info;
      v.gtype = v.info.gtype;
      v.orderNo = v.info.bid;
      v.orderDate = v.info.createtime;
      v.totalprice = v.info.bamount;
      v.tableData = v.info.bcontent;
      v.year = (v.info.bcontent[0].amount/12).toFixed(0);
      v.ordersum = v.info.bcontent.length;
      v.gmodel = v.info.bcontent[0].gmodel;
      v.query();
    }
  },
  mounted() {}
});
</script>
<style scoped>
.main {
  overflow: auto;
}
.orderdeline {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #4379ee;
}
.OD-span1 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.OD-span2 {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #333333;
}
.OD-span3 {
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #8295ae;
}
.OD-span4 {
  padding-left: 20px;
  font-size: 20px;
  font-family: Microsoft YaHei;
  font-weight: bold;
}
.service {
  font-size: 15px;
  font-family: Microsoft YaHei;
  font-weight: 400;
}
.OD-span5 {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}
.OD-span6 {
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  margin-top: 20px;
}
.pad-top {
  padding-top: 20px;
}
.pad-left {
  padding-left: 39px;
}
.totalprice {
  padding: 20px 0;
}
</style>